import React, { useEffect, useRef, useState } from "react";
import { appearances } from "../Timeline/timelineData";

// Talks, podcasts and media, newest first, as a quiet list below the timeline
const SHOWN = 6;

const Appearances = ({ className }) => {
  const listRef = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const items = [...appearances].sort((a, b) => b.date.localeCompare(a.date));
  const shown = expanded ? items : items.slice(0, SHOWN);

  // Each row settles in once it scrolls into view, like the timeline's commits
  useEffect(() => {
    const observer = new IntersectionObserver(
      (rows) => {
        rows.forEach((row) => {
          if (row.isIntersecting) {
            row.target.classList.add("inView");
            observer.unobserve(row.target);
          }
        });
      },
      { rootMargin: "0px 0px -10% 0px" },
    );
    listRef.current
      .querySelectorAll(".appearance:not(.inView)")
      .forEach((row) => observer.observe(row));
    return () => observer.disconnect();
  }, [expanded]);

  return (
    <section
      className={"appearances" + (className ? ` ${className}` : "")}
      aria-labelledby="appearancesLabel"
    >
      <h3 id="appearancesLabel" className="appearancesLabel">
        Talks, media &amp; more
      </h3>
      <ol className="appearancesList" ref={listRef}>
        {shown.map((a) => (
          <li key={a.id} className="appearance">
            <a href={a.url} target="_blank" rel="noopener noreferrer">
              <span className="appearanceDate">{a.period}</span>
              <span className="appearanceBody">
                <span className="appearanceTitle">{a.title}</span>
                <span className="appearanceTalk">{a.place}</span>
              </span>
              <span className="appearanceFormat">{a.format}</span>
            </a>
          </li>
        ))}
      </ol>
      {items.length > SHOWN && (
        <button
          type="button"
          className="talkMore"
          aria-expanded={expanded}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show less" : `Show ${items.length - SHOWN} more`}
        </button>
      )}
    </section>
  );
};

export default Appearances;
